import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { CardColor, Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";

export default class WidgetKPICards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      nbInterview: 0,
      nbSIM1: 0,
      nbUpdate: 0,
      nbAudit: 0,
      nbAuditPA: 0,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    let loaded = 0;
    const total = 5;
    const checkLoaded = () => {
      loaded++;
      if (loaded >= total) this.setState({ isLoad: false });
    };

    axiosConfig("home/count-interview").then((res) => {
      if (res.data.success) this.setState({ nbInterview: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-sim").then((res) => {
      if (res.data.success) this.setState({ nbSIM1: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-update").then((res) => {
      if (res.data.success) this.setState({ nbUpdate: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-audit").then((res) => {
      if (res.data.success) this.setState({ nbAudit: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-audit-pa").then((res) => {
      if (res.data.success) this.setState({ nbAuditPA: res.data.data });
      checkLoaded();
    });
  }

  redirect(page) {
    let type = "";
    const t = Number(this.context.type);
    if ([4, 5].includes(t)) {
      type = "assistant";
    } else if ([0, 1, 2].includes(t)) {
      type = "expert";
    } else {
      type = "expert-EAD";
    }

    const links = {
      0: `/entretien-${type}`,
      1: `/sim1-${type}`,
      2: "/library",
      3: "/update",
      4: "/audit-technical",
      5: "/result-plan-actions",
    };

    if (links[page]) {
      document.location.href = links[page];
    }
  }

  getCardsForRole() {
    const role = Number(this.context.role);
    const { nbInterview, nbSIM1, nbUpdate, nbAudit, nbAuditPA } = this.state;

    const cards = {
      interview: {
        title: "Entretiens non clos cette année",
        count: nbInterview,
        className: nbInterview === 0 ? "bg-green" : "bg-orange",
        onClick: () => this.redirect(0),
        size: { xs: 12, md: 4 },
      },
      sim: {
        title: "SIM1 non clos cette année",
        count: nbSIM1,
        className: nbSIM1 === 0 ? "bg-green" : "bg-orange",
        onClick: () => this.redirect(1),
        size: { xs: 12, md: 4 },
      },
      update: {
        title: "Mises à jour ce mois-ci",
        count: nbUpdate,
        className: "bg-green",
        onClick: () => this.redirect(3),
        size: { xs: 12, md: 4 },
      },
      audit: {
        title: "Audits réalisés cette année",
        count: nbAudit,
        className: "bg-blue",
        onClick: () => this.redirect(4),
        size: { xs: 12, md: 6 },
      },
      auditPA: {
        title: "Audits plan d'action cette année",
        count: nbAuditPA,
        className: "bg-blue",
        onClick: () => this.redirect(5),
        size: { xs: 12, md: 6 },
      },
    };

    // Dirigeant: all cards
    if (role === 4) {
      return [cards.interview, cards.sim, cards.update, cards.audit, cards.auditPA];
    }
    // Responsable technique: all cards
    if (role === 1) {
      return [cards.interview, cards.sim, cards.audit, cards.auditPA, cards.update];
    }
    // Responsable administratif: interviews, sim, updates, satisfaction
    if (role === 2) {
      return [cards.interview, cards.sim, cards.update];
    }
    // DRH: all
    if (role === 3) {
      return [cards.interview, cards.sim, cards.update, cards.audit];
    }
    // Expert (role 0, type 0/1/2): personal
    if ([0, 1, 2].includes(Number(this.context.type))) {
      return [cards.interview, cards.sim, cards.update, cards.audit];
    }
    // Assistant (role 0, type 3/4/5)
    return [cards.interview, cards.sim, cards.update];
  }

  render() {
    if (this.state.isLoad) {
      return (
        <WidgetWrapper
          title="Indicateurs clefs"
          noCard
          isCustomizing={this.props.isCustomizing}
          dragHandleProps={this.props.dragHandleProps}
          onHide={this.props.onHide}
        >
          <Loader />
        </WidgetWrapper>
      );
    }

    const cards = this.getCardsForRole();

    return (
      <WidgetWrapper
        title="Indicateurs clefs"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        <Row>
          {cards.map((card, idx) => (
            <Col
              key={idx}
              xs={card.size.xs}
              md={card.size.md}
            >
              <CardColor
                title={card.title}
                count={card.count}
                className={`mb-10 ${card.className}`}
                onClick={card.onClick}
              />
            </Col>
          ))}
        </Row>
      </WidgetWrapper>
    );
  }
}
